import React from 'react';

export const Footer = () => (
    <footer className="footer">

    </footer>
);
